import { parseCalendarDate } from '../../dates/index.js';
import { toCreditLineInput } from './to-credit-line-input.js';
/** The caller mints the idempotency key once per open dialog, so a retried submit replays the same credit. */
export function toIssuePromotionCreditInput(values, idempotencyKey) {
    return {
        customerId: values.customerId,
        brandId: values.brandId,
        promotionCreditTypeId: Number(values.promotionCreditTypeId),
        amount: Number(values.amount),
        dateApplicable: values.dateApplicable || undefined,
        expirationDate: values.expirationDate ? parseCalendarDate(values.expirationDate) : undefined,
        details: values.details.trim() || undefined,
        notes: values.notes.trim() || undefined,
        promotionId: values.promotionId || undefined,
        lines: values.lines.length > 0 ? values.lines.map(toCreditLineInput) : undefined,
        idempotencyKey,
    };
}
//# sourceMappingURL=issue-mapper.js.map